import { WorkflowGroupUserView } from 'app/models/WorkflowGroupUserView';
import { WorkflowForm } from './WorkflowForm';
import { AttachmentView } from './form/AttachmentView';
import { FormCommentView } from './form/FormCommentView';
import { WorkflowGroupEntityView } from 'app/models/WorkflowGroupEntityView';

export interface WorkflowApprovalGroupUserDto {
	id: number;
	userId: string;
	firstName: string;
	lastName: string;
	title: string;
	email: string;
	sendEmailNotification: boolean;
	isThreshold: boolean;
}

export interface WorkflowApprovalGroupEntityDto {
	id: number;
	entityType: string;
	entityId: number;
}

export interface WorkflowApprovalGroupProjectGrantDto {
	id: number;
	projectGrantId: string;
}

export interface WorkflowApprovalGroupSegmentDto {
	id: number;
	segmentId: string;
	subSegments: any[];
}

export interface WorkflowApprovalGroupVendorDto {
	id: number;
	vendorId: string;
}

export interface WorkflowApprovalGroupPoNumberDto {
	id: number;
	poNumber: string;
}

export interface WorkflowApprovalGroupGroupDto {
	id: number;
	value: string;
	isThreshold: boolean;
}

export interface WorkflowApprovalGroupInvoiceTypeDto {
	id: number;
	invoiceTypeConfigurationId: string | null;
}

export enum ThresholdType {
	GreaterThan = 0,
	LessThan = 1,
	Between = 2,
}

export enum ConditionField {
	Department = 'Department',
	ThresholdValue = 'ThresholdValue',
	SpecificUser = 'SpecificUser',
	Account = 'Account',
	Fund = 'Fund',
}

export enum ConditionOperator {
	Equals = 'Equals',
	NotEquals = 'NotEquals',
	GreaterThan = 'GreaterThan',
	GreaterThanOrEqual = 'GreaterThanOrEqual',
	LessThan = 'LessThan',
	LessThanOrEqual = 'LessThanOrEqual',
	Between = 'Between',
	Contains = 'Contains',
	NotContains = 'NotContains',
}

export enum ConditionLogic {
	AND = 'AND',
	OR = 'OR',
}

export interface RuleCondition {
	id?: string;
	field: ConditionField;
	operator: ConditionOperator;
	value: string | number;
	lowValue?: number | null;
	highValue?: number | null;
	logicToNext?: ConditionLogic;
	order?: number;
}

export interface RuleBasedRule {
	id?: string;
	name?: string;
	conditions: RuleCondition[];
	approvers: WorkflowApprovalGroupUserDto[];
	approverGroups: WorkflowApprovalGroupGroupDto[];
	totalRequiredApprovals: number;
}

export interface WorkflowApprovalGroupDto {
	id: number;
	order: number;
	name?: string;
	totalRequiredApprovals: number;
	thresholdValue?: number;
	thresholdType?: ThresholdType;
	lowValue?: number;
	highValue?: number;
	thresholdTotalRequiredApprovals: number;
	showNonThresholdUsers: boolean;
	users: WorkflowApprovalGroupUserDto[];
	groupEntities: WorkflowApprovalGroupEntityDto[];
	groupProjectGrants: WorkflowApprovalGroupProjectGrantDto[];
	groupVendors: WorkflowApprovalGroupVendorDto[];
	groupPoNumbers: WorkflowApprovalGroupPoNumberDto[];
	groups: WorkflowApprovalGroupGroupDto[];
	rules?: RuleBasedRule[];
	groupInvoiceTypes: WorkflowApprovalGroupInvoiceTypeDto[];
	groupSegments: WorkflowApprovalGroupSegmentDto[];
}

export interface WorkflowGroupDto extends WorkflowForm {
	isDraft: boolean;
	clientId: string;
	oldId: number;
	name: string;
	isLegacyFormat?: boolean;

	// NEW: Multiple approval groups
	approvalGroups?: WorkflowApprovalGroupDto[];

	// Legacy properties - populated for old forms
	totalRequiredApprovals?: number;
	thresholdValue?: number;
	workflowType: number;
	users?: WorkflowGroupUserView[];
	documents: AttachmentView[];
	comments: FormCommentView[];
	groupEntities?: WorkflowGroupEntityView[];
	groupProjectGrants?: any[];
	groupVendors?: any[];
	groupPoNumbers?: any[];
	groups?: any[];
	groupInvoiceTypes?: any[];
	groupSegments?: WorkflowApprovalGroupSegmentDto[];
	showNonThresholdUsers?: boolean;
	thresholdTotalRequiredApprovals?: number;
}
